import React, { useCallback, useState } from 'react'
import DriveFileMoveRoundedIcon from '@mui/icons-material/DriveFileMoveRounded';
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar'
import '../../css/common.css'
import '../../css/firmware.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiService } from '../../services/apiService';
import Warning from '../../common/alert/Warning';

export default function FirmwareUpload() {

	const navigate = useNavigate();
	let props = useLocation();

	const [fileValue, setFileValue] = useState({});
	const [fileName, setFileName] = useState(props.state === null ? "" : props.state.filename);
	const [fwVersion, setFwVersion] = useState(props.state === null ? "" : props.state.fwver);
	const [fileSize, setFileSize] = useState("");
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	const changeHandleFile = async (e) => {
		// setFileValue(e.currentTarget.files);
		// setFileName(e.target.files[0].name);
		if(e.target.files[0]) {
			const base64 = await createBase64Data(e.currentTarget.files[0]);
			// console.log('base64', base64);
			setFileValue(base64);
			setFileName(e.target.files[0].name.replace(/^.*[\\\/]/, ''));
			setFileSize(e.target.files[0].size);
		}

	}

	const createBase64Data = (file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);  // 인코딩
			reader.onload = () => {
				let base64Data = reader.result;
				// console.log('test', base64Data)
				const base64Content = base64Data.replace(/^data:.+;base64,/, '');
				// console.log("base64Data : %s", base64Content);
				resolve(base64Content);
			}
			reader.onerror = error => reject(error);
		});

	}

	const changeHandleVersion = (e) => {
		setFwVersion(e.target.value);
	}

	const handleClick = async(e) => {
		e.preventDefault();
		const firmwareData = {
			"filename" : fileName,
			"fwver" : fwVersion,
			"fwsize" : fileSize,
			"file" : fileValue,
		}

		try {
			await ApiService.firmwareUpload(firmwareData);
			navigate("/firmware");
		} catch(error) {
			setOpenWarning(true);
			setErrorMsg('업로드 실패!');
			console.log('FirmwareUpload - handleClick - error :: ',error);
		}
	}
	
	return (
		<div className="containList">
			{ (props.state !== null) ? (
				<BreadCrumbBar menu="펌웨어 관리" smenu="펌웨어 세부정보"/>
				) : (
					<BreadCrumbBar menu="펌웨어 관리" smenu="펌웨어 업로드"/>
				)
			}
			<form className="uploadform">
				{
					(props.state !== null) ? (
						<div className="textBox">
							<label htmlFor="filename" className="textLabel">파일명</label>
							<input type="text" id="filename" defaultValue={fileName} disabled></input>
						</div>
					) 
					: (
						<div className="filebox">
							<label className="textLabel">파일첨부</label>
							<label htmlFor="file" className="filebutton"><DriveFileMoveRoundedIcon/></label> 
							<input type="file" id="file" onChange={changeHandleFile}></input>
							<input type="text" defaultValue={fileName} disabled></input>
						</div>
					) 
				}

				<div className="textBox">
					<label htmlFor="version" className="textLabel">파일버전</label>
					{
						(props.state !== null) ? (
							<input type="text" id="version" defaultValue={fwVersion} disabled></input>
						) 
						: (
							<input type="text" id="version" defaultValue={fwVersion} onChange={changeHandleVersion}></input>
						) 
					}
				</div>

				<div className="buttonBox">
					{
						(props.state !== null) ? (
							<button className="listbutton" onClick={(e) => {e.preventDefault(); navigate("/firmware")}}>목록</button>
						) 
						: (
							<>
								<button className="listbutton" onClick={(e) => {e.preventDefault(); navigate("/firmware")}}>목록</button>
								<button className="uploadbutton" onClick={handleClick}>업로드</button>
							</>
						) 
					}
				</div>
			</form>

			<Warning
				open={openWarning}
				onHideWarning={closeWarning}
				warningMsg={errorMsg}
			></Warning>
		</div>
	)
}
